var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fo-header',{attrs:{"selected":"/team"},on:{"selected":function (e) {}}}),_vm._v(" "),_c('teamAll',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.params.param),expression:"!$route.params.param"}]}),_vm._v(" "),(_vm.$route.params.param)?_c('teamDtl'):_vm._e(),_vm._v(" "),_c('fo-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cb01602","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Team.vue
// module id = null
// module chunks = 